import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/Service/auth.service';
import { EventService } from 'src/app/Service/event.service';
import { SharedConstants } from 'src/app/models/index';
import { ConfirmationDialog } from '../../dialogs/ConfirmationDialog';
import * as L from 'leaflet';
import { ScheduleService } from 'src/app/Service/schedule.service';
import { ParentList } from '../groups/model/IGroups';
import { GroupsAdapterService } from '../groups/services/groups-adapter.service';
import { CaeUserCreate } from 'src/app/models/shared/cae-user';
import { utilsApps } from 'src/app/helpers/utils-app';
import { CaeUserService } from 'src/app/Service/cae-user-service.service';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { HttpClient } from '@angular/common/http';
import { NgOption } from '@ng-select/ng-select';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CatStatusGeneric } from 'src/app/models/shared/cat-status-generic';

@Component({
  selector: 'app-create-cae-user',
  templateUrl: './create-cae-user.component.html'
})

export class CreateCaeUserComponent implements OnInit {
  fmUser: FormGroup;
  currentUser: any;
  photo: File;

  protected hourList: string[] = [];
  _utils: utilsApps;
  map: any;
  showMap: boolean = false;


  /** For controller the confirms dialogs */
  public confirmationDialog: ConfirmationDialog = new ConfirmationDialog();
  public isConfirmationDialog: boolean = false;

  /** For use translate */
  protected msg_confirmDialog: string = "";
  protected msgTwo_confirmDialog: string = "";

  msg_address_not_found: string = "";

  regexImail: string;
  public listAccessGroup: Array<ParentList> = [];
  public listUserGroup: Array<ParentList> = [];

  currentApiKey: string;
  data: any;
  branches: NgOption[] = [];
  selected: any[] = [];


  Entity: CaeUserCreate = {
    name: "",
    email: "",
    phone: "",
    password: "",
    title: "",
    department: "",
    user_group: "",
    access_group: "",
    period_start: undefined,
    period_end: undefined,
    face: undefined,
    userId: 0,
    enabled: true
  };


  waitFor = false;
  searchLabel: string = "";
  regexGeographicCoordinates: string;
  photoPreview: SafeUrl;
  catStatus: CatStatusGeneric[] = [];
  constructor(
    private sharedConstants: SharedConstants,
    private _fb: FormBuilder,
    private readonly scheduleService: ScheduleService,
    private translate: TranslateService,
    private readonly http: HttpClient,
    private authService: AuthService,
    private GroupsAdapterService: GroupsAdapterService,
    protected eventService: EventService,
    private readonly _service: CaeUserService,
    private _modalService: NgbModal,
    private sanitizer: DomSanitizer // <-- Agregado
  ) {
    this.regexImail = this.sharedConstants.regexPattern.emailValidator;
    this.regexGeographicCoordinates = this.sharedConstants.regexPattern.geographicCoordinates;

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;

      console.log(this.currentUser);
    });

    this.fmUser = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(48)]],
      email: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(50), Validators.pattern(this.regexImail)]],
      phone: [''],
      job_title: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(48)]],
      department: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
      accessGroupId: ['', [Validators.required]],
      userGroupId: ['', [Validators.required]],
      photo: [null, [Validators.required]],
      periodStartDate: ['', [Validators.required]],
      periodStartHour: ['', [Validators.required]],
      periodEndDate: ['', [Validators.required]],
      periodEndHour: ['', [Validators.required]],
      rbStatusId: ['1', [Validators.required]]
    });

  }

  async ngOnInit(): Promise<void> {




    try {
      this.eventService.startLoadingData();

      this.catStatus = [
        {
          id: 1,
          name: "Activo",
          value: "1",
          keyLg: "Active"
        },
        {
          id: 0,
          name: "Inactivo",
          value: "0",
          keyLg: "Inactive"
        }
      ];

      this.hourList = this.scheduleService.getListHours(60);
      this.listAccessGroup = await this.getAccessGroup();
      this.listUserGroup = await this.getUserGroup();
      this.getDataLanguage();

      this.eventService.completeLoadingData();

    } catch (error) {
      console.log(error);
    }

  }


  private async getAccessGroup(): Promise<Array<ParentList>> {

    let response = await this.GroupsAdapterService.getAccessGroup();
    console.log("getAccessGroup", response);
    console.log("getAccessGroup", response.data);

    if (response.status) {
      return response.data.map((group: any) => {
        console.log("getAccessGroup", group);
        return { id: group.id, name: group.name };
      });
    } else {
      return [];
    }

  }

  private async getUserGroup(): Promise<Array<ParentList>> {
    let response = await this.GroupsAdapterService.getUserGroup();
    if (response.status) {
      return response.data.map((group: any) => {
        return { id: group.id, name: group.name };
      });
    } else {
      return [];
    }
  }


  public getIdCompany(): number {
    if (this.currentUser) {
      if (this.currentUser.branches && this.currentUser.branches.length > 0) {
        return parseInt(this.currentUser.branches[0].idCompany);
      }
    }
    return 0;
  }


  onSave() {
    try {

      this.eventService.startLoadingData();

      this._utils = new utilsApps();

      const reader = new FileReader();
      let periodStartDate = this.fmUser.get("periodStartDate")?.value;
      let periodStartHour = this.fmUser.get("periodStartHour")?.value;
      let periodEndDate = this.fmUser.get("periodEndDate")?.value;
      let periodEndHour = this.fmUser.get("periodEndHour")?.value;

      let dateStart = this._utils.fnDateToString(periodStartDate, "-") + "T" + periodStartHour + ":00" + this._utils.GetTimeZoneOffset();
      let dateEnd = this._utils.fnDateToString(periodEndDate, "-") + "T" + periodEndHour + ":00" + this._utils.GetTimeZoneOffset();


      if (dateStart > dateEnd) {
        this.eventService.errorMessage(3, "cae-user.catMsg.DATE_NOT_VALID");
        this.eventService.completeLoadingData();
      } else {
        reader.readAsDataURL(this.photo);
        reader.onload = () => {
          this.waitFor = true;
          let resultFile = reader.result;

          this.Entity.face = resultFile.toString().split(',')[1];
          this.Entity.name = this.fmUser.get("name")?.value;
          this.Entity.access_group = this.fmUser.get("accessGroupId")?.value;
          this.Entity.user_group = this.fmUser.get("userGroupId")?.value;
          this.Entity.email = this.fmUser.get("email")?.value;
          this.Entity.phone = this.fmUser.get("phone")?.value;
          this.Entity.title = this.fmUser.get("job_title")?.value;
          this.Entity.department = this.fmUser.get("department")?.value;
          this.Entity.period_start = dateStart;
          this.Entity.period_end = dateEnd;
          this.Entity.enabled = this.fmUser.get("rbStatusId")?.value == '1' ? true : false;
          this.Entity.userId = this.currentUser.id;
          console.log(this.Entity);

          this._service.postPersonIdentitum(this.Entity).subscribe({
            next: (response: any) => {
              console.log(response);
              let code = response?.body?.code;
              let content = response?.body?.content;

              if (code === "SUCCESS") {
                this.eventService.successMessage(1);
                this.onClose(1);

                //recargar pantalla
                setTimeout(() => {
                  window.location.reload();
                }, 3000);

              } else {

                let msg = "cae-user.catMsg.";
                if (code == "ALREADY_EXISTS" || code == "FILE_NOT_PERSISTED"
                  || code == "NOT_PERSISTED" || code == "CONNECTION_FAILURE"
                  || code == "INVALID_RESPONSE_identitum" || code == "INVALID_SECURITY_CONFIG") {
                  this.eventService.errorMessage(3, msg + code);
                }
                else if (code == "DUPLICATED" && content != null && content.includes("email")) {
                  this.eventService.errorMessage(3, msg + "DUPLICATED");
                }
                else {
                  this.translate.stream('common.error500').subscribe((res: string) => {
                    this.eventService.errorMessage(0, res);
                  });
                }
              }

              this.waitFor = false;
              this.eventService.completeLoadingData();
            },
            error: (error: Response) => {
              console.log(error);
              this.eventService.errorMessage(2);
              this.eventService.completeLoadingData();
            }
          });

        };
      }

    } catch (error) {
      this.eventService.completeLoadingData();
      console.log(error);
    }
  }

  onShowMap() {

    let coordinates = this.fmUser.get("coordinates")?.value;
    let coordinatesArray = coordinates.split(',');

    if (coordinatesArray.length == 2) {
      let ltd: number, lng: number;
      ltd = coordinatesArray[0];
      lng = coordinatesArray[1];
      this.showMap = !this.showMap;
      this.setMarkerToMap(ltd, lng);
    }
    else {
      this.fmUser.get('coordinates')?.updateValueAndValidity();
    }
  }

  loadMap() {

    console.log("Cargando mapa... ");
    let ltd, lng;
    //19.43899318656144, -99.1780088846568
    ltd = 19.43899318656144;
    lng = -99.1780088846568;

    if (this.map == undefined) {
      this.map = L.map('map', {
        center: [ltd, lng],
        zoom: 18,
      });
      this.addGeoSearchControl();
    }

    const tiles = L.tileLayer(
      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        maxZoom: 18,
      }
    );
    tiles.addTo(this.map);

    //Evento click
    this.map.on('click', e => {

      //Elimina los marcadores previos
      this.map.eachLayer(function (layer) {
        if (layer.options && layer.options.pane === "markerPane") {
          layer.remove();
        }
      });

      let coor = e.latlng;
      let value = coor.lat + ',' + coor.lng;
      this.fmUser.get("coordinates").setValue(value);
      this.setMarkerToMap(coor.lat, coor.lng);
    });

  }

  public setMarkerToMap(ltd: number, lng: number) {
    console.log("setMarkerToMap");

    //Elimina los marcadores previos
    this.map.eachLayer(function (layer) {
      layer.remove();
    });

    const greenIcon = new this.customLeafIcon({
      className: 'custom-green-marker',
    });

    let customMarker = greenIcon;

    //Crea y agrega el marcador
    L.marker([ltd, lng], { icon: customMarker, draggable: false })
      .addTo(this.map)
      .openPopup();

    //Agrega la capa del mapa
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        maxZoom: 18,
      }
    );
    tiles.addTo(this.map);
    //cambia posición del mapa
    this.map.panTo(new L.LatLng(ltd, lng));
  }

  private addGeoSearchControl(): void {
    const provider = new OpenStreetMapProvider();
    const control = GeoSearchControl({
      provider: provider,
      style: 'bar', // Optional: 'button' or 'bar'
      notFoundMessage: this.msg_address_not_found,
      autoComplete: true,
      searchLabel: this.searchLabel,
      autoCompleteDelay: 250,
      showMarker: false, // Optional: Show a marker when a location is found
    });
    this.map.addControl(control);
    console.log("Agregando control de búsqueda...");
  }

  customLeafIcon = L.DivIcon.extend({
    options: {
      html: "<div style='background-color:#4838cc;' class='marker-pin'></div>",
      iconSize: [30, 42],
      iconAnchor: [15, 42],
    },
  });


  get fmDet() { return this.fmUser.controls; }


  onCloseModalReference(name: string) {
  }

  onClearData() {

  }

  private getDataLanguage() {
    this.translate.stream('common.confirmDialog.messageCancel').subscribe((res: string) => {
      this.msg_confirmDialog = res;
    });
    this.translate.stream('common.confirmDialog.messageTwoCancel').subscribe((res: string) => {
      this.msgTwo_confirmDialog = res;
    });

    this.translate.stream('cae-user.catMsg.ADDRESS_NOT_FOUND').subscribe((res: string) => {
      this.msg_address_not_found = res;
    });

    this.translate.stream('cae-user.catMsg.SEARCHLABEL_CONTROL').subscribe((res: string) => {
      this.searchLabel = res;
    });

  }



  /**
   * For actions of by confirms dialogs, to do the correct process
   * @param $event For know the action to do
   */
  protected onClose(action: number): void {
    /** For active confirm dialog */
    if (action === 0) {
      this.confirmationDialog.keyConfirmDialog = "confirmExitCreateCAEUser";
      this.confirmationDialog.message = this.msg_confirmDialog;
      this.confirmationDialog.messageTwo = this.msgTwo_confirmDialog;
      this.isConfirmationDialog = true;
    }
    /** For confirm action of confirm dialog */
    if (action === 1) {
      this.onClearData();
      this._modalService.dismissAll();
    }
  }

  /**
   * For actions of by confirms dialogs, to do the correct process
   * @param $event For know the action to do
   */
  protected orchestratorCloseDialog($event: any): void {
    if (this.confirmationDialog.keyConfirmDialog === "confirmExitCreateCAEUser") {
      this.onClose($event);
    }
    this.isConfirmationDialog = false;
    this.confirmationDialog = new ConfirmationDialog();
  }


  protected setHour(hour: string, controlName: string): void {
    this.fmUser.get(controlName).setValue(hour);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      const file = input.files[0];

      if (file.size <= 2000000) {
        this.fmUser.get('photo').setValue(file);
        this.fmUser.get('photo')?.updateValueAndValidity();
        this.photo = file;
        // Previsualización de la imagen cargada, sanitizada
        const objectUrl = URL.createObjectURL(file);
        this.photoPreview = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      }
      else {
        this.eventService.errorMessage(3, "cae-user.catMsg.FILE_TOO_BIG");
      }
    }
  }

}